import React from "react"
import ReactGA from "react-ga4";
import { Image, Stack } from "react-bootstrap";
import tcapLogo from '../../assets/tcap-coin.png';
import institutionalLogo from '../../assets/cryptex_institutional.png';


const InstitutionalPage = () => {
  ReactGA.send({ hitType: "pageview", page: "/Institutional", title: "Institutional" });

  return (
    <Stack className="flex flex-row align-items-center justify-content-center h-80 px-2 mt-5 pt-5 mt-sm-0 pt-sm-0">
      <div
        className="flex flex-column flex-unset align-items-center justify-content-center h-3/4 gap-4"
        style={{ maxWidth: "950px", minWidth: "400px" }}
      >
        <Image
          src={institutionalLogo}
          alt="Cryptex Institutional"
          width={300}
          className="mb-1"
        />
        <h3 className="fw-bolder text-black">Regulated index products for the next era of allocators.</h3>
        <Stack
          className="d-flex flex-column align-items-center justify-content-center bg-card border-card px-4 py-3 rounded-sm gap-3"
        >
          <Stack className="flex flex-row gap-2">
            <Image
              src={tcapLogo}
              alt="Crypto ETP"
              width={28}
              height={28}
            />
            <h4 className="fw-bolder">Total Crypto Market Cap ETP</h4>
          </Stack>
          <Stack className="flex flex-col gap-2">
            <p className="text-purple fw-bold"> 
              A Tokenized Index Fund. Regulated by Design. Powered by Chainlink.
            </p>
            <p className="text-black">
              Cryptex is developing the first tokenized Exchange Traded Product (ETP) tracking the Total Crypto Market Cap—structured
              to comply with the Investment Company Act of 1940.
            </p>
            <ul>
              <li>
                40-asset index <span className="text-purple fw-bold">covering ~87%</span> of the total crypto market cap.
              </li>
              <li>
                <span className="text-purple fw-bold">Bitcoin capped</span> at 55%.
              </li>
              <li>
                Fully custody-backed with third-party <span className="text-purple fw-bold">custodial attestations</span>.
              </li>
              <li>
                Real-time NAV via Chainlink <span className="text-purple fw-bold">Proof of Reserve</span> and price oracles.
              </li>
            </ul>
            <p className="text-black">
              Purpose-built for registered investment advisors, family offices, and compliant crypto allocators.
            </p>
          </Stack>
          <div
            className="w-100 p-2 text-center border-card"
            style={{ backgroundColor: "#F3F4F6", borderRadius: "5px" }}
          >
            <span className="w-100 fs-5 text-purple fw-bolder">Coming Soon.</span>
          </div>
        </Stack>
      </div>  
    </Stack>
  )
};

export default InstitutionalPage;
